import {
  Plan,
  Feature,
  hasFeature as entHasFeature,
} from './entitlements.js';

class PlanContext {
  private plan: Plan = Plan.FREE;

  getPlan(): Plan {
    return this.plan;
  }

  setPlan(plan: Plan): void {
    this.plan = plan;
  }

  hasFeature(feature: Feature): boolean {
    return entHasFeature(this.plan, feature);
  }
}

export { Plan, Feature };
export const planContext = new PlanContext();
